import { useCallback, useEffect, useState } from "react";
import { list } from "../lib/api";

export function useCollection<T>(path: string, params: Record<string, string | number | boolean | null | undefined> = {}) {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const query = JSON.stringify(params);

  const reload = useCallback(async (background = false) => {
    background ? setRefreshing(true) : setLoading(true);
    setError(null);
    try { setItems(await list<T>(path, JSON.parse(query) as typeof params)); }
    catch (reason) { setError(reason instanceof Error ? reason.message : "暂时无法读取数据"); }
    finally { setLoading(false); setRefreshing(false); }
  }, [path, query]);

  useEffect(() => { void reload(); }, [reload]);
  useEffect(() => {
    const onFocus = () => { if (document.visibilityState === "visible") void reload(true); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [reload]);

  return { items, setItems, loading, refreshing, error, reload };
}
